const HEX_PATTERN = /^#(?:[0-9a-f]{3}|[0-9a-f]{6})$/i;

export function normaliseHex(color?: string | null): string | null {
  if (!color) return null;
  const value = color.trim();
  if (!HEX_PATTERN.test(value)) {
    return null;
  }
  if (value.length === 4) {
    const r = value[1];
    const g = value[2];
    const b = value[3];
    return `#${r}${r}${g}${g}${b}${b}`.toUpperCase();
  }
  return value.length === 7 ? value.toUpperCase() : null;
}

interface RgbValue {
  r: number;
  g: number;
  b: number;
}

export function hexToRgb(hex: string): RgbValue {
  const value = hex.startsWith('#') ? hex.slice(1) : hex;
  const r = parseInt(value.slice(0, 2), 16);
  const g = parseInt(value.slice(2, 4), 16);
  const b = parseInt(value.slice(4, 6), 16);
  return { r, g, b };
}

export function rgbToHex({ r, g, b }: RgbValue): string {
  const toHex = (component: number) => component.toString(16).padStart(2, '0');
  return `#${toHex(r)}${toHex(g)}${toHex(b)}`.toUpperCase();
}

export function mixHexColors(baseHex: string, mixHex: string, ratio: number): string {
  const base = hexToRgb(baseHex);
  const mix = hexToRgb(mixHex);
  const clampRatio = Math.max(0, Math.min(1, ratio));
  const blended = {
    r: Math.round(base.r * (1 - clampRatio) + mix.r * clampRatio),
    g: Math.round(base.g * (1 - clampRatio) + mix.g * clampRatio),
    b: Math.round(base.b * (1 - clampRatio) + mix.b * clampRatio),
  };
  return rgbToHex(blended);
}

export function hexToRgba(hex: string, alpha: number): string {
  const { r, g, b } = hexToRgb(hex);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}
